import { Props } from '../TransferServiceSummary';
import { useMemo } from 'react';
import { ServiceSummaryOptionsType } from '../../../../ServiceSummary/types';

export const useTransferServiceSummary = (
	service: Props['service'],
	segments: Props['segments'],
	passengers: Props['passengers'],
	servicesState: Props['servicesState']
) => {
	const serviceSummaryOptions = useMemo<ServiceSummaryOptionsType[]>(() => {
		const serviceSummaryOptions: ServiceSummaryOptionsType[] = [];

		for (const [passengerId] of Object.keys(servicesState)) {
			const summaryOption: ServiceSummaryOptionsType = {
				header: passengers[passengerId].fullName,
				items: []
			};

			for (const [segmentId] of Object.keys(servicesState[passengerId])) {
				const passengerService = servicesState[passengerId][segmentId].find(
					passengerService => passengerService.service.id === service.id
				);

				if (!passengerService) {
					continue;
				}

				if (passengerService.selected) {
					summaryOption.items.push({
						price: service.price,
						name: `${segments[segmentId].date}, ${segments[segmentId].city}`,
						id: passengerService.service.id
					});
				}
			}
			serviceSummaryOptions.push(summaryOption);
		}

		return serviceSummaryOptions.filter(summaryOption => summaryOption.items?.length);
	}, [servicesState, segments, service]);

	return {
		serviceSummaryOptions
	};
};
